import axios from 'axios'
import ajax from '@/lib/ajax'

const webUrl = 'http://qy.chinapsp.cn:48889'

const fileAjax = axios.create({
	baseURL: webUrl
});

let localFile = {
  // 上传文件
  async uploadFile (file) {
    console.log(file)
    let formData = new FormData()
    formData.append('file', file)
    let rep = await fileAjax.post('/api/services/app/DBFileInfo/UploadAbpFileAsync', formData)
    if (rep.data.success) {
      return rep.data.result
    }
    return false
  },
  // 下载blob文件
  async downLoadBlob(fileId, fileName = '', extension = '') {
    let rep = ''
    if (fileName && extension) {
      rep = await fileAjax.get('/api/Download/DownloadDBFileByFileGuid', { params: { serviceGuid: fileId, fileName, extension }, responseType: 'blob' })
    } else {
      rep = await fileAjax.get('/api/Download/DownloadDBFile', { params: { serviceGuid: fileId }, responseType: 'blob' })
    }
    let blob = new Blob([rep.data])
    let fileUrl = window.URL.createObjectURL(blob)
    return fileUrl
  },
  // blob 链接跳转下载
  currentLoad (blobUrl, fileName) {
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = blobUrl
    link.setAttribute('download', fileName)
    document.body.append(link)
    link.click()
    document.body.removeChild(link)
  },
  // 跳转下载文件
  directLoadFile (fileId, fileName = '', extension = '') {
    if (fileName && extension) {
      window.open(`${webUrl}/api/Download/DownloadDBFileByFileGuid?serviceGuid=${fileId}&fileName=${fileName}&extension=${extension}`)
    } else {
      window.open(`${webUrl}/api/Download/DownloadDBFile?serviceGuid=${fileId}`)
    }
  },
  // 创建dbfile记录
  async createFileRecord (data) {
    let rep = await ajax.post('/api/services/app/ClDbFile/CreateOrUpdate', {
      clDbFile: data
    })
    if (rep.data.success) {
      return true
    }
    return false
  },
  // 拼接上传链接
  getDownUrl (fileId) {
    return `${webUrl}/api/Download/DownloadDBFile?serviceGuid=${fileId}`
  },
  // 根据ossfilename和ossid获取永久链接
  async getPermanentDownUrl (bucket, fileName) {
    let rep = await fileAjax.get('/api/services/app/AbpAliOss/GetSampleDownloadUrl', {
      params: {
        bucket,
        fileName
      }
    })
    return rep.data.result
  }
}

export default localFile;